class InfiniteScroll extends HTMLElement {
  constructor() {
    super();
    this.nextUrl = this.dataset.nextUrl;
    this.sectionId = this.dataset.sectionId;
    this.productGrid = document.getElementById('product-grid');
    this.loading = false;

    if (!this.nextUrl || !this.productGrid) return;

    this.observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !this.loading) {
          this.loadMore();
        }
      },
      { rootMargin: '400px' }
    );

    this.observer.observe(this);
  }

  async loadMore() {
    this.loading = true;
    this.querySelector('.infinite-scroll__spinner').classList.remove('hidden');

    try {
      const separator = this.nextUrl.includes('?') ? '&' : '?';
      const url = `${this.nextUrl}${separator}section_id=${this.sectionId}`;
      const response = await fetch(url);
      const text = await response.text();
      const html = new DOMParser().parseFromString(text, 'text/html');

      const newItems = html.querySelectorAll('#product-grid > li');
      newItems.forEach((item) => {
        item.querySelectorAll('.scroll-trigger').forEach((el) => {
          el.classList.add('scroll-trigger--cancel');
        });
        this.productGrid.appendChild(item);
      });

      const nextScroll = html.querySelector('infinite-scroll');
      if (nextScroll && nextScroll.dataset.nextUrl) {
        this.nextUrl = nextScroll.dataset.nextUrl;
        this.loading = false;
      } else {
        this.observer.disconnect();
        this.remove();
      }
    } catch (e) {
      console.error('Infinite scroll fetch failed:', e);
      this.loading = false;
    }

    const spinner = this.querySelector('.infinite-scroll__spinner');
    if (spinner) spinner.classList.add('hidden');
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
  }
}

customElements.define('infinite-scroll', InfiniteScroll);
